import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function CancellationRefundPolicy() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div id='CancellationRefundPolicy' className="container py-5" style={{marginTop: '7rem'}}>
      <div className="mb-4" data-aos="fade-up">
        <h1 className="display-5 fw-bold">Cancellation & Refund Policy</h1>
        <p className="text-muted">Last updated on April 1, 2024</p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <p>
          At Rayan Info Solutions, we operate under a strict **no cancellation and no refund policy** for all services rendered.
          Once a service has been confirmed and initiated, it is considered final and non-refundable.
        </p>
        <p>
          This policy applies to all software development, consulting, deployment, and maintenance agreements. Clients are advised
          to carefully review their requirements and reach out with any questions before confirming services or making payment.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <p>
          If you have concerns regarding deliverables or service expectations, we encourage you to contact us directly at{' '}
          <a href="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</a>. Our team is committed to resolving
          legitimate issues through professional support, even though cancellations or refunds are not permitted.
        </p>
      </div>

      <div className="pt-3 border-top" data-aos="fade-up">
        <p className="mb-0 fw-semibold">Rayan Info Solutions</p>
        <p className="text-muted">Thank you for your understanding and trust in our services.</p>
      </div>
    </div>
  );
}
